import { Model } from "@vuex-orm/core";

export class MStation extends Model {
    static get entity() {
        return "m_stations"
    }

    static fields() {
        return {
            "id": this.attr(null),
            "m_station_name": this.string(""),
            "create_by": this.attr(null),
            "update_by": this.attr(null),
            "createdAt": this.attr(null),
            "updatedAt": this.attr(null),
            "mDivisionId": this.attr(null)
        }
    }

    static get apiConfig() {
        return {
            actions: {
                findAll(params = {}) {
                    return this.get('/m_station', { params });
                },

                create(body) {
                    return this.post('/m_station', body);
                },

                update(id, body) {
                    return this.put(`/m_station/${id}`, body);
                },

                destroy(id) {
                    return this.delete(`/m_station/${id}`, { delete: id });
                }
            }
        };
    }
}